const galleryData = {
    "מקלחונים": [
      "https://res.cloudinary.com/dvmyddd9z/image/upload/f_jpg,q_auto/v1769348063/IMG_4155_ryk7nd",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348063/IMG_2470_y3ndks",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348062/IMG_5203_zfrwjz.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348062/IMG_2396_hpogt5.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348062/IMG_1151_kqbvuw.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348061/IMG_2462_qswnbi.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348060/IMG_3723_pg8nxy.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348059/IMG_2410_lpzmzu.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348058/IMG_2405_vonksd.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348058/IMG_0555_ejwfty.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348057/IMG_2357_hcpf3y.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348057/IMG_1502_jgyoyw.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348057/IMG_2527_wcmclk.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348057/IMG_8400_t69oxg.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348057/IMG_9326_ysg1zf.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348055/IMG_4132_wl0sge.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348055/IMG_2392_yyouvl.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348055/IMG_4748_h5zbyy.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348054/IMG_8188_j3hel8.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348054/IMG_8222_l3ilaz.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348054/IMG_6843_bst6qj.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348053/IMG_7483_utgitz.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348053/IMG_0194_biepkh.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348053/7BBA2715-7053-4DDC-8741-4D6B6DF39188_fvzi95.jpg",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348053/IMG_7501_jqijqq.heic",
      "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348053/IMG_7783_w13vha.heic"

    ],
    
    "מעקות":[
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347956/IMG_7880_kgzcgi.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347954/IMG_3160_hxl2gl.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347954/IMG_3458_txaxgt.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347951/IMG_8073_rz9wbg.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347949/IMG_4486_ei0y59.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347947/IMG_3149_d3pbpw.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347947/IMG_4958_xvanu0.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347945/IMG_4481_bw3nth.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347945/IMG_0260_xonvg0.jpg",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347945/IMG_3022_bconlz.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347943/IMG_3826_uafcdr.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347941/IMG_7853_fzg5l3.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347941/IMG_0259_it9cal.jpg",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347940/IMG_8088_k9v51y.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347939/IMG_4348_qcgpbz.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347939/IMG_8526_n6bngu.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347939/IMG_0507_vcnvhs.jpg",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347939/A6FB7CA2-A3F6-4BF2-A1C7-B529D8DA1085_sqzct2.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347937/IMG_7162_nx6wxc.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347937/B4E5E56E-CACD-4660-8142-3D77C02E6AA2_klvcs7.jpg",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347937/IMG_8964_xzdv1i.heic"
        

    ],

    "מראות":[
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351996/IMG_3939_hpvxco.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351994/IMG_5235_effapm.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351993/IMG_9793_mojpsb.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351991/IMG_5875_toeyks.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351991/IMG_5207_nftbfk.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351988/IMG_9806_omut2n.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351987/IMG_6006_phmmdu.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351985/IMG_9404_yqikun.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351984/IMG_5785_nag8a9.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351983/IMG_3952_bqoeeh.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351982/1CF27BAA-5D62-4805-A0E3-3799EF277E39_mrvzvj.jpg",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351981/IMG_8229_zld7qb.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351981/IMG_0026_wgogio.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351979/IMG_5226_gv04ob.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351979/9632ec05-f361-4345-9293-b96f6203a5ba_ffm3mh.jpg"
        
    ],
    "ויטרינות":[
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352558/IMG_4567_n89hpr.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352555/IMG_3720_vshcze.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352553/IMG_3777_qbc4pa.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352551/IMG_1816_twgnjk.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352549/IMG_1993_ioehga.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352548/IMG_2956_p99at7.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352545/IMG_8323_qxkbxo.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352542/IMG_8964_xjlikm.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352540/IMG_2191_f5lrnb.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352538/IMG_8100_vudmjr.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352536/IMG_8119_rxt7in.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352534/IMG_1990_tb0kba.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352532/IMG_4568_uj2xk1.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352530/IMG_8271_yq0aqw.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352528/FullSizeRender_fp20wa.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352525/IMG_4659_l5m0bl.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352524/IMG_8097_rtuvjc.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352521/IMG_1127_ovizic.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352519/IMG_1131_rlbe8y.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352517/IMG_6317_edqxro.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352515/IMG_6725_eqfwzj.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352512/IMG_8104_k0jxtv.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352511/IMG_6730_og8rzo.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352508/IMG_4365_uguobe.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352506/IMG_8133_srx1eq.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352504/IMG_8294_izwnoi.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352502/IMG_8332_pjlwsl.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352500/IMG_4310_o0rubx.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352498/IMG_6721_fa55xp.heic",
       "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352497/IMG_9386_r1xle9.heic"


    ],
    
    
  };
  export default galleryData;